import { render, staticRenderFns } from "./match_result.vue?vue&type=template&id=ef201190&scoped=true&"
import script from "./match_result.vue?vue&type=script&lang=js&"
export * from "./match_result.vue?vue&type=script&lang=js&"
import style0 from "./match_result.vue?vue&type=style&index=0&id=ef201190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef201190",
  null
  
)

export default component.exports